/* eslint-disable @next/next/no-page-custom-font */
import { createContext, useState } from 'react';
import Head from 'next/head';
import { CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { ReactQueryDevtools } from 'react-query/devtools';
import { QueryClient, QueryClientProvider } from 'react-query';

import Layout from '../components/Layout'
import { SidebarProvider } from '../helpers/contextHelpers';
import theme from '../styles/theme';
import '../styles/globals.scss';
import { RTAuthWrapper } from '@videostream/route-this-login-react';
import posthog from "posthog-js"
import { PostHogProvider } from 'posthog-js/react'

// Check that PostHog is client-side
console.log('NEXT_PUBLIC_POSTHOG_KEY', process.env.NEXT_PUBLIC_POSTHOG_KEY);
console.log('NEXT_PUBLIC_POSTHOG_HOST', process.env.NEXT_PUBLIC_POSTHOG_HOST);
if (typeof window !== 'undefined') {
  posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY, {
    api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST || 'https://app.posthog.com',
    person_profiles: 'identified_only',
    // Enable debug mode in development
    loaded: (posthog) => {
      // if (process.env.NODE_ENV === 'development') posthog.debug()
    }
  })
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      cacheTime: Infinity,
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    } 
  }
});

function MyApp({ Component, pageProps }) {
  const [locale, setLocale] = useState(() => {
    if (typeof window !== "undefined" && 
      typeof navigator !== "undefined") {
      return navigator.language;
    }
    return 'en';
  });

  // viewing certificates doesn't need authenticating
  if (Component.skipAuth) {
    return (
      <Component {...pageProps} />
    )
  }

  return (
    <PostHogProvider client={posthog}>
      <RTAuthWrapper 
      apiUrl={process.env.NEXT_PUBLIC_AUTH_API_URL} 
      redirectUrl='/' 
      locale={locale}
      flags={{ showSSOSettings : false, hideUserPermissions : true }} >
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <Head>
              <title>RouteThis Certify</title>
            </Head>
            <QueryClientProvider client={queryClient}>
                {Component.hideNav ? <Component {...pageProps} /> : (
                  <SidebarProvider>
                    <Layout>
                      <Component {...pageProps} />
                    </Layout>
                  </SidebarProvider>
                )}
              {process.env.NODE_ENV === 'development' ? <ReactQueryDevtools /> : null}
            </QueryClientProvider>
          </ThemeProvider>
      </RTAuthWrapper>
    </PostHogProvider>
  );
}

export default MyApp
